export class MonthWiseAttendanceDto {
    costCenterName: string;
    projectName: string;
    subContractorName: string;
    year: string;
    month: string;
    day: string;
    attenStatus: string;
  }
